import React from 'react';
import { CTAButton } from './CTAButton';
interface SectionCTAProps {
  transformation: string;
  label: string;
  subline: string;
  tone?: 'go' | 'navy';
  onDark?: boolean;
}
export function SectionCTA({
  transformation,
  label,
  subline,
  tone = 'go',
  onDark = false
}: SectionCTAProps) {
  return <div className="mx-auto mt-10 max-w-md" data-id="element-72" data-mp="1qav5txzme16m">
      <p className={`mb-3 text-center font-display text-[17px] italic leading-snug sm:text-lg ${onDark ? 'text-white/85' : 'text-ink-soft'}`} data-id="element-73" data-mp="1qdr3rmbgwpv2">
        {transformation}
      </p>
      <CTAButton label={label} subline={subline} tone={tone} data-id="element-74" data-mp="12mbyplsb3ug4" />
    </div>;
}